import { Injectable } from '@angular/core';
import { Observable, finalize } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiHandlerService {
  constructor() {}

  /**
   * @description ฟังก์ชันกลางสำหรับเรียก API แล้วจัดการ subscribe + error + log ให้
   * @param apiCall - Observable จาก service เดิม (เช่น this.apiService.getUser())
   * @param options - การตั้งค่าเพิ่มเติม เช่น showSuccess, message ฯลฯ
   */
  handleApi<T>(
    apiCall: Observable<T>,
    options: {
      success?: (data: T ) => void; // ค่าสำเร็จ
      error?: (err: any ) => void; // ค่าผิดพลาด
      finally?: () => void; // ค่าจบทำงาน สําเร็จหรือผิดพลาด ทั้งหมด
      showToast?: boolean;
      logLabel: string;
      isConsoleLog: boolean;
      loading?: ( loading : boolean ) => boolean;
    }
  ): void {
    options?.loading?.(true);
    apiCall
      .pipe(finalize(() => options?.finally?.()))
      .subscribe({
        // ตรวจสอบ log label
        next: (response) => {
          options?.loading?.(false);
          // ตรวจสอบ log label success
          if (options?.isConsoleLog) {           
            console.log(`✅ API response [${options.logLabel}] : \n `,
               "*** [ Response ] ***",
               response
            );         
          }
          options?.success?.(response );// ส่งค่าออก

        },
        error: (error) => {
          options?.loading?.(false);
          // ตรวจสอบ log label error
          if (options?.isConsoleLog) {  
            console.error(`❌ API error [${options.logLabel}] : \n `,
              "*** [ Error ] ***",
               error 
            );          
          }
          options?.error?.(error);// ส่งค่าออก
        },
      });
  }
}
